var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangepasswordMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.942,
    height: 17.959,
    viewBox: "0 0 13.942 17.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Change_password",
    "data-name": "Change password",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change_Password-2",
    "data-name": "Change Password"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 12.442,
    height: 9.872,
    rx: 1.7,
    transform: "translate(0 6.587)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M14.863,7.918V5.153A3.253,3.253,0,0,0,11.61,1.9H10.553A3.253,3.253,0,0,0,7.3,5.153V7.918Z",
    transform: "translate(-4.86 -1.9)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangepasswordMenuIcon);
export default __webpack_public_path__ + "static/media/changepassword-menu-icon.f60245faf709268615f06f2dbe36e514.svg";
export { ForwardRef as ReactComponent };